import * as React from 'react';
import { compose } from 'redux';
import { Helmet } from 'react-helmet';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { InjectedTranslateProps, translate } from 'react-i18next';
import 'react-toastify/dist/ReactToastify.css';

import i18n from './../../lib/i18n';

export type MainProps = RouteComponentProps<any> & InjectedTranslateProps;

const Main: React.FunctionComponent<MainProps> = ({ children, t }) => {
  const GTM_CODE = 'GTM-N98J'; // TODO: This could go into configuration
  return (
    <div className='app'>
      <Helmet htmlAttributes={{ lang: i18n.language }}>
        <title>{t('application-title')}</title>
        <meta name='description' content={t('application-description')} />
        {GTM_CODE ? (
          <script>
            {`(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
            new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
            j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
            'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
            })(window,document,'script','dataLayer','${GTM_CODE}');`}
          </script>
        ) : null}
      </Helmet>
      <div className='bg' />
      {children}
    </div>
  );
};

export default compose<any>(
  withRouter,
  translate()
)(Main);



// WEBPACK FOOTER //
// ./node_modules/eslint-loader!./src/components/main/index.tsx